(ns dre.modals.admin.help.views
  (:require
   [dre.components.loading-spinner :refer [loading-spinner]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.admin.help.events :as admin-help]
   [dre.modals.modal-window :refer [modal-window]]
   [re-frame.core :as rf]))

(defn- add-help-topic-content
  []
  (let [component-name :add-help-topic]
    [:div
     {:class [component-name :admin-modal-window-content]}
     [:div.input-group
      [:span.label
       [tr "Help Topic"]]
      [:input.input
       {:type :text
        :value @(rf/subscribe [::admin-help/value-of [:add-help-topic :confluence-id]])
        :on-change #(rf/dispatch [::admin-help/on-change [:add-help-topic :confluence-id] (.. % -target -value)])}]]]))

(defn add-help-topic
  []
  [modal-window
   {:title "Add Help Topic"
    :content add-help-topic-content
    :submit? true
    :submit-text [tr "Create"]
    :on-submit #(rf/dispatch [::admin-help/add-help-topic])}])

(defn- add-confluence-article-content
  []
  (let [component-name :add-confluence-article]
    [:div
     {:class [component-name :admin-modal-window-content]}
     [:div.input-group
      [:span.label
       [tr "Help Topic"]]
      [:input.input
       {:type :text
        :disabled true
        :value @(rf/subscribe [::admin-help/value-of [:add-confluence-article :help-topic]])}]]
     [:div.input-group
      [:span.label
       [tr "Confluence ID"]]
      [:input.input
       {:type :text
        :value @(rf/subscribe [::admin-help/value-of [:add-confluence-article :confluence-id]])
        :on-change #(do
                      (rf/dispatch [::admin-help/on-change [:add-confluence-article :confluence-id] (.. % -target -value)])
                      (rf/dispatch [::admin-help/fetch-confluence-title (.. % -target -value)]))}]]
     [:div.input-group
      [:span.label
       [tr "Title (retrieved from Confluence)"]]
      [:input.input
       {:type :text
        :disabled true
        :value @(rf/subscribe [::admin-help/value-of [:add-confluence-article :title]])}]]]))

(defn add-confluence-article
  []
  [modal-window
   {:title "Add Confluence Article"
    :content add-confluence-article-content
    :submit? true
    :submit-text [tr "Create"]
    :on-submit #(rf/dispatch [::admin-help/add-confluence-article])}])

(defn- delete-help-topic-content
  []
  (let [component-name :delete-help-topic]
    [:div
     {:class [component-name :admin-modal-window-content]}
     [:div.input-group
      [:span.label
       [tr "Help Topic"]]
      [:input.input
       {:type :text
        :disabled true
        :value @(rf/subscribe [::admin-help/value-of [:delete-help-topic :confluence-id]])}]]]))

(defn delete-help-topic
  []
  [modal-window
   {:title "Delete Help Topic"
    :content delete-help-topic-content
    :delete? true
    :on-delete #(rf/dispatch [::admin-help/delete-help-topic])}])

(defn- preview-help-topic-content
  []
  (let [component-name :preview-help-topic]
    [:div
     {:class [component-name :admin-modal-window-content]}
     (if @(rf/subscribe [::admin-help/preview-loading?])
       [loading-spinner]
       [:div
        {:dangerouslySetInnerHTML
         {:__html @(rf/subscribe [::admin-help/value-of [:preview-help-topic :content]])}}])]))

(defn preview-help-topic
  []
  [modal-window
   {:title "Preview"
    :content preview-help-topic-content}])

(defn- delete-confluence-article-content
  []
  (let [component-name :delete-confluence-article]
    [:div
     {:class [component-name :admin-modal-window-content]}
     [:div.input-group
      [:span.label
       [tr "Help Topic"]]
      [:input.input
       {:type :text
        :disabled true}]]
     [:div.input-group
      [:span.label
       [tr "Confluence ID"]]
      [:input.input
       {:type :text
        :disabled true}]]
     [:div.input-group
      [:span.label
       [tr "Title"]]
      [:input.input
       {:type :text
        :disabled true}]]]))

(defn delete-confluence-article
  []
  [modal-window
   {:title "Delete Confluence Article"
    :content delete-confluence-article-content
    :delete? true
    :on-delete #(println "TODO")}])
